// extracted by mini-css-extract-plugin
export default {"headSpace":"head-space_headSpace__pJWD2"};